import { core } from '@musinsa/pbo-core'
import type { FilterFieldSpec } from '@musinsa/pbo-core'

// GL01 합배송출고 — .handoff/gl-gl01__20260826-1424 spec.md · schema.after.json 기준.
// 컬럼은 스키마에서 기계 생성했다. 손으로 폭·순서를 바꾸지 말 것 — 데모와 1:1 이 깨진다.

/** 화주 옵션 — 데모는 5개 화주를 열어두지만 BE 는 MUSINSAGLOBAL 외 400 을 낸다(2026-07-10 회의 확정). */
export const SHIPPER_OPTIONS = [{ value: 'MUSINSAGLOBAL', label: '무신사글로벌' }]

/**
 * 필터 9종 — prod MOMS_FILTER_INFO GL01 FILTER_CD 와 BE 조회 파라미터에 맞춘다.
 * TEXT_MULTI(다건 코드입력)는 mfs.FormTextArea, 단건 텍스트는 mfs.FormInput + plain.
 */
export const FILTER_FIELDS: FilterFieldSpec[] = [
  // allOption 은 안 주면 true 가 기본이라 '전체' 가 붙는다. 화주는 필수 + 단일이고 BE 가
  // MUSINSAGLOBAL 외에는 400 을 내므로 고를 수 없는 값을 보여주면 안 된다 — 명시로 끈다.
  {
    id: 'SPR_NM',
    type: 'mfs.FormSelect',
    label: '화주명',
    required: true,
    mode: 'single',
    allOption: false,
    options: SHIPPER_OPTIONS,
    defaultValue: 'MUSINSAGLOBAL',
  },
  { id: 'ORD_DATE', type: 'mfs.FormDatepicker', label: '주문일자', required: true, chip: '오늘', defaultPeriod: 'today', periodBase: 'pastTo' },
  { id: 'OUB_PDATE', type: 'mfs.FormDatepicker', label: '출고예정일' },
  { id: 'SPR_ORD_NO', type: 'mfs.FormTextArea', label: '고객사주문번호' },
  { id: 'INB_TRS_INVOICE', type: 'mfs.FormInput', label: '송장번호(입고)', plain: true },
  { id: 'REF_NO2', type: 'mfs.FormTextArea', label: '글로벌송장' },
  // SVC_TYPE·ORD_STATUS 옵션은 비동기(GET /api/v1/combos) — 화면(ConsolOutboundFilter)에서 주입한다.
  { id: 'SVC_TYPE', type: 'mfs.FormSelect', label: '서비스 유형', mode: 'single', allOption: true, options: [] },
  { id: 'ORD_NO', type: 'mfs.FormTextArea', label: '주문번호' },
  { id: 'ORD_STATUS', type: 'mfs.FormSelect', label: '주문상태', mode: 'single', allOption: true, options: [] },
]

/**
 * 표 컬럼 84종 — 스키마 gl01Table.columns 를 그대로 옮겼다(제목·폭·순서·고정·변형).
 * 단언을 쓰는 이유: groupColor 변형의 `groupKey` 는 pbo-core 0.7.4 variantProps 공개 타입에 아직 없다.
 * 런타임은 읽고 있으므로 스키마 값을 그대로 둔다.
 */
export const GL01_COLUMNS = [
  {"key":"c-rowType","title":"","width":14,"fixed":"left","variant":"groupColor","variantProps":{"groupKey":"SPR_ORD_NO"}},
  {"key":"c-sprOrdNo","title":"주문 번호","dataIndex":"SPR_ORD_NO","width":168,"fixed":"left"},
  {"key":"c-refNo1","title":"배송 번호","dataIndex":"REF_NO1","width":183},
  {"key":"c-trsCountry","title":"배송 국가","dataIndex":"TRS_COUNTRY","width":100},
  {"key":"c-sprOrdOptNo","title":"주문 상세 번호","dataIndex":"SPR_ORD_OPT_NO","width":180},
  {"key":"c-sprDlvStatus","title":"배송 상태","dataIndex":"SPR_DLV_STATUS","width":110},
  {"key":"c-refMemo1","title":"배송 처리 현황 메모","dataIndex":"REF_MEMO1","width":237,"variant":"input"},
  {"key":"c-refMemo2","title":"배송 메모","dataIndex":"REF_MEMO2","width":160,"variant":"input"},
  {"key":"c-ordDate","title":"주문일시","dataIndex":"ORD_DATE","width":160},
  {"key":"c-payDate","title":"입금 일자","dataIndex":"PAY_DATE","width":160},
  {"key":"c-venGroup","title":"구분","dataIndex":"VEN_GROUP","width":90},
  {"key":"c-sprOrdStatus","title":"주문 상태","dataIndex":"SPR_ORD_STATUS","width":110},
  {"key":"c-gdsOpt","title":"상품 옵션","dataIndex":"GDS_OPT","width":140},
  {"key":"c-ordQty","title":"주문 수량","dataIndex":"ORD_QTY","width":110,"align":"right"},
  {"key":"c-refMemo3","title":"메모 내용","dataIndex":"REF_MEMO3","width":240,"variant":"input"},
  {"key":"c-refMemo4","title":"메모 상태","dataIndex":"REF_MEMO4","width":110,"variant":"input"},
  {"key":"c-gdsCd","title":"상품 번호","dataIndex":"GDS_CD","width":130},
  {"key":"c-gdsType","title":"상품 구분","dataIndex":"GDS_TYPE","width":110},
  {"key":"c-stlNo","title":"스타일 번호","dataIndex":"STL_NO","width":161},
  {"key":"c-comNm","title":"업체 ID","dataIndex":"COM_NM","width":110},
  {"key":"c-gdsGroup1","title":"상품 카테고리","dataIndex":"GDS_GROUP1","width":130},
  {"key":"c-imgUrl","title":"상품 url","dataIndex":"IMG_URL","width":240,"variant":"link"},
  {"key":"c-brdNm","title":"브랜드 명","dataIndex":"BRD_NM","width":140},
  {"key":"c-gdsLocation","title":"상품 위치","dataIndex":"GDS_LOCATION","width":110},
  {"key":"c-gdsNm","title":"상품명(한글)","dataIndex":"GDS_NM","width":240},
  {"key":"c-venGiType","title":"출고 예정 구분","dataIndex":"VEN_GI_TYPE","width":140},
  {"key":"c-venPgiDate","title":"출고 기한","dataIndex":"VEN_PGI_DATE","width":150},
  {"key":"c-venCentercd","title":"국내(출/반품지 번호)","dataIndex":"VEN_CENTERCD","width":180},
  {"key":"c-venCenternm","title":"국내(출 반품지 명)","dataIndex":"VEN_CENTERNM","width":170},
  {"key":"c-venDlvType","title":"배송 구분","dataIndex":"VEN_DLV_TYPE","width":110},
  {"key":"c-refCenter1","title":"글로벌(센터 번호)","dataIndex":"REF_CENTER1","width":160},
  {"key":"c-refCenter2","title":"글로벌(센터명)","dataIndex":"REF_CENTER2","width":150},
  {"key":"c-refCenter3","title":"글로벌(센터 수령자명)","dataIndex":"REF_CENTER3","width":190},
  {"key":"c-refCenter4","title":"글로벌(센터 우편번호)","dataIndex":"REF_CENTER4","width":190},
  {"key":"c-refCenter5","title":"글로벌(센터 주소 1)","dataIndex":"REF_CENTER5","width":220},
  {"key":"c-refCenter6","title":"글로벌(센터 주소 2)","dataIndex":"REF_CENTER6","width":180},
  {"key":"c-refCenter7","title":"글로벌(전화번호)","dataIndex":"REF_CENTER7","width":160},
  {"key":"c-ordNm","title":"주문자 이름","dataIndex":"ORD_NM","width":130},
  {"key":"c-ordId","title":"주문자 식별자","dataIndex":"ORD_ID","width":130},
  {"key":"c-ordEmail","title":"주문자 이메일","dataIndex":"ORD_EMAIL","width":200},
  {"key":"c-sprCutDate","title":"출고 차수 생성일(출고 요청 일시)","dataIndex":"SPR_CUT_DATE","width":250},
  {"key":"c-venGiDate","title":"출고 완료 일시","dataIndex":"VEN_GI_DATE","width":160},
  {"key":"c-refDate1","title":"국내 이동 중 일시","dataIndex":"REF_DATE1","width":170},
  {"key":"c-refDate2","title":"선적지 출발 중 일시","dataIndex":"REF_DATE2","width":180},
  {"key":"c-dlvDate","title":"최종 배송 완료 일시(업체)","dataIndex":"DLV_DATE","width":210},
  {"key":"c-refDate3","title":"최종 배송 완료 일시(시스템 기록)","dataIndex":"REF_DATE3","width":250},
  {"key":"c-refPeriod1","title":"출고 기간","dataIndex":"REF_PERIOD1","width":110},
  {"key":"c-refPeriod2","title":"배송 클레임 기간","dataIndex":"REF_PERIOD2","width":150},
  {"key":"c-refPeriod3","title":"배송 기간","dataIndex":"REF_PERIOD3","width":110},
  {"key":"c-inbTrsInvoice","title":"국내 송장 번호 (입고송장)","dataIndex":"INB_TRS_INVOICE","width":200},
  {"key":"c-refUrl1","title":"국내 송장 트래킹 URL","dataIndex":"REF_URL1","width":230,"variant":"link"},
  {"key":"c-refLsp1","title":"국내 택배 업체 코드","dataIndex":"REF_LSP1","width":160},
  {"key":"c-refNo2","title":"글로벌 송장 번호","dataIndex":"REF_NO2","width":170},
  {"key":"c-refUrl2","title":"글로벌 송장 트래킹 URL","dataIndex":"REF_URL2","width":230,"variant":"link"},
  {"key":"c-refLsp2","title":"글로벌 택배사 코드","dataIndex":"REF_LSP2","width":160},
  {"key":"c-csmNm","title":"수령자 명","dataIndex":"CSM_NM","width":130},
  {"key":"c-csmZip","title":"수령지 우편 번호","dataIndex":"CSM_ZIP","width":150},
  {"key":"c-csmState","title":"수령지 주","dataIndex":"CSM_STATE","width":110},
  {"key":"c-csmCity","title":"수령지 도시","dataIndex":"CSM_CITY","width":130},
  {"key":"c-csmAddr1","title":"수령지 주소-1","dataIndex":"CSM_ADDR1","width":220},
  {"key":"c-csmAddr2","title":"수령지 주소-2","dataIndex":"CSM_ADDR2","width":160},
  {"key":"c-inbCenter","title":"입고센터","dataIndex":"INB_CENTER","width":110},
  {"key":"c-oubCenter","title":"출고센터","dataIndex":"OUB_CENTER","width":110},
  {"key":"c-inbPdate","title":"입고 예정일","dataIndex":"INB_PDATE","width":150},
  {"key":"c-inbAdate","title":"입고일","dataIndex":"INB_ADATE","width":150},
  {"key":"c-oubPdate","title":"출고예정일","dataIndex":"OUB_PDATE","width":150},
  {"key":"c-oubAdate","title":"출고일","dataIndex":"OUB_ADATE","width":150},
  {"key":"c-ordConsolNo","title":"합포장번호","dataIndex":"ORD_CONSOL_NO","width":187},
  {"key":"c-invType","title":"재고유형 (수량/주문)","dataIndex":"INV_TYPE","width":170},
  {"key":"c-svcType","title":"서비스 유형","dataIndex":"SVC_TYPE","width":130},
  {"key":"c-clsDate","title":"마감일","dataIndex":"CLS_DATE","width":150},
  {"key":"c-cutSeq","title":"마감차수","dataIndex":"CUT_SEQ","width":100},
  {"key":"c-oubClsDate","title":"출고마감일","dataIndex":"OUB_CLS_DATE","width":150},
  {"key":"c-oubCutSeq","title":"출고마감차수","dataIndex":"OUB_CUT_SEQ","width":130},
  {"key":"c-inbClsDate","title":"입고마감일","dataIndex":"INB_CLS_DATE","width":150},
  {"key":"c-inbCutSeq","title":"입고마감차수","dataIndex":"INB_CUT_SEQ","width":130},
  {"key":"c-ordType","title":"주문유형","dataIndex":"ORD_TYPE","width":110},
  {"key":"c-trsType","title":"배송유형","dataIndex":"TRS_TYPE","width":110},
  {"key":"c-sprNm","title":"고객사명","dataIndex":"SPR_NM","width":140},
  {"key":"c-oubTrsInvoice","title":"출고송장","dataIndex":"OUB_TRS_INVOICE","width":191},
  {"key":"c-ordNo","title":"주문번호","dataIndex":"ORD_NO","width":160},
  {"key":"c-ordOptNo","title":"주문일련번호","dataIndex":"ORD_OPT_NO","width":170},
  {"key":"c-refDate4","title":"국내 배송 완료 일시","dataIndex":"REF_DATE4","width":190},
  {"key":"c-ordStatus","title":"주문상태(MOMS)","dataIndex":"ORD_STATUS","width":160},
] as core.CoreColumnType[]

/** 상세사유 최소 길이 — BE 가 5자 미만이면 400. */
export const REASON_DETAIL_MIN_LENGTH = 5
export const REASON_DETAIL_MAX_LENGTH = 200

/**
 * 압축 파일 비밀번호 규칙 — 8자 이상 · 소문자 · 대문자 · 숫자 · 특수문자.
 * 옛 ExcelDownloadModal 이 [확인] 을 잠가 지키던 선이다. 생성본 모달에는 그 잠금이 없어
 *  화면 배선(index.tsx)이 같은 선을 지킨다 — 규칙은 여기 한 곳에만 둔다.
 */
export const ZIP_PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/
export const isValidZipPassword = (password: string): boolean => ZIP_PASSWORD_RULE.test(password)

/**
 * 재전송 비활성 사유 — 사용자에게 보이는 문구다. 내부 티켓번호나 백엔드 사정은 담지 않는다.
 *
 * 배경: 2.0 백엔드에 대응 엔드포인트가 없다. LOGISPRD-9605 가 구현 보류이고 근거는 prod
 * 사용실적이다(ui_api_status 기준 SND_DO_TO_WH 가 2026-03-04 이후 0건). 1.0
 * internal/data/send 우회는 moms-be-1.0 호출 금지에 걸려 하지 않았다.
 */
export const RESEND_DISABLED_REASON = '재전송 기능은 현재 준비 중입니다.'

/** 잔여출고확정 안내 모달 폭 — 안내 문구가 길어 기본(416)으로는 줄바꿈이 심하다. */
export const REMAINING_RELEASE_MODAL_WIDTH = 520

/** 목록 검색 대상 — dataIndex 가 있는 컬럼만. 색상 막대(ROW_TYPE)처럼 글자로 안 보이는 값은 뺀다. */
export const GL01_SEARCHABLE_KEYS: readonly string[] = GL01_COLUMNS.map((c) => c.dataIndex).filter(
  (d): d is string => typeof d === 'string',
)
